{
  "instances": {
    "details": {
      "label": "Detalhes",
      "cache": {
        "hit_ratio": "Hit ratio",
        "hits": "Hits",
        "misses": "Falhas",
        "size": "Tamanho"
      },
      "datasource": {
        "active_connections": "Conexões ativas",
        "min_connections": "Conexões mínimas",
        "max_connections": "Conexões máximas",
        "title": "Datasource: {dataSource}",
        "unlimited": "ilimitado"
      },
      "gc": {
        "count": "Contador",
        "time_spent_max": "Tempo máximo gasto",
        "time_spent_total": "Tempo total gasto",
        "title": "Pausas do Garbage Collection"
      },
      "health": {
        "title": "Integridade",
        "toggle_details": "Alternar detalhes de integridade de {name}"
      },
      "health_group": {
        "title": "Grupo de Integridade"
      },
      "info": {
        "no_info_provided": "Nenhuma informação fornecida.",
        "title": "Info"
      },
      "memory": {
        "max": "Máximo",
        "metaspace": "Metaspace",
        "size": "Tamanho",
        "title": "Memoria",
        "used": "Usado",
        "committed": "Comprometido"
      },
      "metadata": {
        "no_data_provided": "Nenhum metadado fornecido.",
        "title": "Metadado"
      },
      "process": {
        "cpus": "CPUs",
        "pid": "PID",
        "parent_pid": "PID Pai",
        "owner": "Proprietário",
        "process_cpu_usage": "Uso de Process CPU",
        "system_cpu_usage": "Uso de System CPU",
        "title": "Processo",
        "uptime": "Uptime"
      },
      "threads": {
        "daemon": "Daemon",
        "live": "Ativos",
        "peak_live": "Peak Live",
        "title": "Threads"
      }
    }
  }
}
